module.exports = __webpack_public_path__ + "img/skip-forward-circle-fill.69fdb374.svg";